import React, { useState, useEffect } from "react";
import { getIdData, addData, updateData } from "../../../lib/studentlessonsfortranskript"
import {LessonTypeSelect ,ClassForTranskriptSelect} from "../../ui/myselect";
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from "../../../usercontext";

export default function StudentTranskriptEdit() {

  //const [classforLesson, setClassForLesson] = useState(9);
  const [lessonType, setLessonType] = useState(null);
  const [className, setClassName] = useState(null);
  const [lessonName, setLessonName] = useState();
  const [grade, setGrade] = useState()
  const [isActive, setIsActive] = useState(true);
  const { profile } = useAuth();
  const [data, setData] = useState([]);

  const navigate = useNavigate();
  let { slug} = useParams();

  const studentId = profile.id;
  //const studentClass =  profile.class;

  async function GetData() {

    const lessonnameData = await getIdData(slug);
    setData(lessonnameData);
    setLessonName(lessonnameData[0].lessonName);
    setIsActive(lessonnameData[0].isActive);
    setLessonType(lessonnameData[0].lessonType)
    setClassName(lessonnameData[0].class);
    setGrade(lessonnameData[0].grade);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (slug === "Add") {
      console.log("Add");
      await addData({
        class : className,
        lessonName: lessonName,
        isActive: isActive,
        studentId:studentId,
        lessonType:lessonType,
        grade : grade
      });
  
    }
    else {
      console.log("Update");
      await updateData({
        id: slug,
        class : className,
        lessonName: lessonName,
        isActive: isActive,
        lessonType:lessonType,
        grade:grade
      });
    }

    navigate("/student/student-transkript");
  };

  useEffect(() => {
    if (slug !== "Add") {
      GetData();
    }

  }, [slug])
  return (
            <div className="col-12">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>{slug === "Add" ? "Add Lesson" : "Update Lesson"}</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Class Name
                            </label>
                            <ClassForTranskriptSelect value={className} setValue={setClassName}/>
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Lesson Type
                            </label>
                            <LessonTypeSelect value={lessonType} setValue={setLessonType}/>
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Lesson Name
                            </label>
                            <input
                              type="text"
                              value={lessonName}
                              onChange={(e) => setLessonName(e.target.value)}
                              className="form-control"
                              placeholder="Enter Lesson Name"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                             Grade
                            </label>
                            <input
                              type="text"
                              value={grade}
                              onChange={(e) => setGrade(e.target.value)}
                              className="form-control"
                              placeholder="Enter Grade"
                              required
                            />
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit" className="btn btn-primary">
                            {slug === "Add" ? "Add Lesson" : "Update Lesson"}
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
  );
}
